<template>
	<div :class="className" :style="style">
		{{ formattedDateTime }}
	</div>
</template>

<script>
/* Libraries */
import WorkerTimer from "@/plugins/WorkerTimer";

export default {
	name: "StationDateTime",

	props: {
		dateTime: {
			type: Object, // moment object
			default: null
		},
		format: {
			type: String,
			default: "hh:mm:ss A"
		},
		className: {
			type: String,
			default: ""
		},
		style: {
			type: Object,
			default: () => ({})
		},
		autoUpdate: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			internalDateTime: null,
			dateTimeInterval: null
		};
	},

	computed: {
		formattedDateTime() {
			// Priority:
			// 1. internalDateTime (the component's live ticking time if auto-updating)
			// 2. dateTime prop (explicitly passed from parent)
			const dateTime = this.internalDateTime || this.dateTime;
			return dateTime.format(this.format);
		}
	},

	methods: {
		startDateTimeInterval() {
			this.internalDateTime = this.dateTime.clone();
			this.dateTimeInterval = WorkerTimer.setInterval(() => {
				this.internalDateTime = this.internalDateTime.clone().add(1, "second");
			}, 1000);
		},

		clearDateTimeInterval() {
			if (this.dateTimeInterval) {
				WorkerTimer.clearInterval(this.dateTimeInterval);
			}
		}
	},

	mounted() {
		if (this.autoUpdate) {
			this.startDateTimeInterval();
		}
	},

	beforeUnmount() {
		this.clearDateTimeInterval();
	},

};
</script>